import { render, staticRenderFns } from "./adminPersonalWait.vue?vue&type=template&id=ec0969fa&scoped=true"
import script from "./adminPersonalWait.vue?vue&type=script&lang=js"
export * from "./adminPersonalWait.vue?vue&type=script&lang=js"
import style0 from "./adminPersonalWait.vue?vue&type=style&index=0&id=ec0969fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0969fa",
  null
  
)

export default component.exports